export default ['Draft', 'Planning', 'Development', 'Live'];
